// let httpUser = `http://boxuser-dev.dhsf.xqhuyu.com` // 用户
// let httpRech = `http://boxp-content-dev.dhsf.xqhuyu.com` // 充值
// let httpContent = `http://pc-content-dev.dhsf.xqhuyu.com` // 内容

// ------------------正式----------------------
let httpUser = `http://user-api.996box.com` // 用户
let httpRech = `http://pay-api.996box.com` // 充值
let httpContent = `http://pc-api.996box.com` // 内容

const firstVersoin = `/v1`  // 第一版
const baseUrl = `/UserInfo`  // 通用
const homeUrl = `/homeapi`   // 首页
const captUrl = `/Captcha`   // 校验
const RegisterUrl = `/Register`  // 注册
const loginUrl = `/Login`  // 登录
const payUrl = `/Pay`      // 充值
const RoleInfoUrl = `/RoleInfo`  // 充值选择
const UserHomeURL = `/UserHomePage`  // 充值选择
const PassWordUrl = `/PassWord`  // 密码修改
const UploadImageUrl = `/UploadImage`  // 用户头像
const UserWalletUrl = `/UserWallet`  // 用户钱包明细
const MessagetUrl = `/Message`  // 消息中心
const OtherUserUrl = `/OtherUserPage`  // 其他用户
const PayStatusUrl = `/PayStatus`  // 充值校验
const OperationUrl = `/Operation`  // 埋点
// console.log(process.env.NODE_ENV)
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
    httpUser = `` // 用户
    httpRech = `` // 充值
    httpContent = `` // 内容
}
export default {
    user: {
        // 登录
        login: `${httpUser}${firstVersoin}${baseUrl}/login`,
        // 登出
        logout: `${httpUser}${firstVersoin}${baseUrl}/logout`,
        // 获取用户信息
        getInfo: `${httpUser}${firstVersoin}${baseUrl}/getByRefresh`,
        // 获取菜单
        getMenu: `${httpUser}${firstVersoin}${baseUrl}/getMenu`,
        // 获取用户信息
        getUserInfo: `${httpUser}${firstVersoin}${baseUrl}/UserInfo`,
        // 下拉框列表获取
        DetailList: `${httpUser}${firstVersoin}${baseUrl}/DetailList`,
        // 获取手机号验证码
        getPhoneCode: `${httpUser}${firstVersoin}${baseUrl}/get_phone_code`,
        // 校验手机验证码
        checkPhoneCode: `${httpUser}${firstVersoin}${baseUrl}/check_phone_code`,
        // 用户首次登陆修改密码
        changeNoPwd: `${httpUser}${firstVersoin}/PassWord/changeNoPwd`,
        // 获取省份地址
        getProvince: `${httpUser}${firstVersoin}${baseUrl}/province`,
        // 获取省下的市
        getRegion: `${httpUser}${firstVersoin}${baseUrl}/city`,
        // 用户主页--我回复的
        replyUser: `${httpUser}${firstVersoin}${UserHomeURL}/reply_user`,
        // 获取当前登录用户信息
        getByRefresh: `${httpUser}${firstVersoin}${baseUrl}/getByRefresh`,
        // 获取推荐头像列表
        getDefineImage: `${httpUser}${firstVersoin}${baseUrl}/head_image_recommend`,
        // 用户编辑资料
        getEdit: `${httpUser}${firstVersoin}${baseUrl}/webedit_profile`,
        // 盒子号更改
        updateAccount: `${httpUser}${firstVersoin}${baseUrl}/update_account`,
        // 用户主页--游戏记录
        gameRecord: `${httpUser}${firstVersoin}${UserHomeURL}/gameRecord`,
        // 用户主页--评价
        user_page_comment: `${httpUser}${firstVersoin}${UserHomeURL}/user_page_comment`,
        // 用户主页--通知
        user_page_notice: `${httpUser}${firstVersoin}${UserHomeURL}/user_page_notice`,
        // 用户主页--回复
        user_page_reply: `${httpUser}${firstVersoin}${UserHomeURL}/user_page_reply`,
        // 上传推荐替换用户头像
        Recommend: `${httpUser}${firstVersoin}${baseUrl}/head_image_replace`,
        // 用户主页--删除消息通知
        del_notice: `${httpUser}${firstVersoin}${UserHomeURL}/del_notice`,
        // 用户主页--通知阅读更改
        read: `${httpUser}${firstVersoin}${UserHomeURL}/read`,
        // 获取其他用户信息
        other_user_info: `${httpUser}${firstVersoin}${baseUrl}/other_user_info`,
        // 其他用户主页---评价
        other_user_comment: `${httpUser}${firstVersoin}${OtherUserUrl}/other_user_comment`,
        // 其他用户主页--回复
        other_user_reply: `${httpUser}${firstVersoin}${OtherUserUrl}/other_user_reply`,
        // 其他用户主页--下载记录
        other_user_download_record: `${httpUser}${firstVersoin}${OtherUserUrl}/other_user_download`,
    },
    home: {
        // 首页信息
        homeindex: `${httpContent}${firstVersoin}${homeUrl}/homeindex/info`,
        // 首页新服推荐换一批
        get_random_open_list: `${httpContent}${firstVersoin}${homeUrl}/homeindex/get_random_open_list`,
        // 新闻列表
        getNewsList: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsList`,
        // 获取新闻详情
        getNewsInfo: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsInfo`,
        // 发现页信息
        byRand: `${httpContent}${firstVersoin}${homeUrl}/FindGame/findAllGameListByRand`,
        // 排行页信息
        withRank: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getGameListWithRank`,
        // 版本与标签接口
        tagList: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getAllVersionAndTagList`,
        // 游戏热搜数据
        hot_search: `${httpUser}${firstVersoin}/Essearch/hot_search`,
        // 搜索框提示词   模糊查询
        query_prefix: `${httpUser}${firstVersoin}/Essearch/query_prefix`,
        // 搜索框随机提示词
        getCueWord: `${httpUser}${firstVersoin}/Essearch/randomCueWord`,
        // 游戏搜索页
        es_search: `${httpUser}${firstVersoin}/Essearch/es_search`,
        // 清空历史记录
        del_history: `${httpUser}${firstVersoin}/Essearch/del_history`,
        // 删除单条历史记录
        del_single_history: `${httpUser}${firstVersoin}/Essearch/del_single_history`,
        // 推荐页-开服列表筛选
        get_index_open_list: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/get_index_open_list`,
        // 新服页-今日开服
        getTodayNewServerList: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getTodayNewServerList`,
        // 新服页-即将开服
        getFutureNewServerList: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getFutureNewServerList`,
        // 时间段配置获取
        getTimeSection: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getTimeSection`,
        // 获取评论
        commentList: `${httpContent}${firstVersoin}${homeUrl}/comment/commentList`,
        // 我的评论
        myComment: `${httpContent}${firstVersoin}${homeUrl}/comment/myComment`,
        // 添加评论
        addComment: `${httpContent}${firstVersoin}${homeUrl}/comment/addComment`,
        // 评论回复列表
        userCommentList: `${httpContent}${firstVersoin}${homeUrl}/comment/userCommentList`,
        // 回复评论
        addUserComment: `${httpContent}${firstVersoin}${homeUrl}/comment/addUserComment`,
        // 删除回复
        delUserComment: `${httpContent}${firstVersoin}${homeUrl}/comment/delUserComment`,
        // 删除评论
        delComment: `${httpContent}${firstVersoin}${homeUrl}/comment/delComment`,
        // 评论页点赞
        commentPraise: `${httpContent}${firstVersoin}${homeUrl}/comment/commentPraise`,
        // 回复页点赞
        replyPraise: `${httpContent}${firstVersoin}${homeUrl}/comment/replyPraise`,
        // 黑词库屏蔽
        getBlackWords: `${httpContent}${firstVersoin}${homeUrl}/Gameindex/getBlackWords`,
        // 获取QQ一键加群KEY
        getQQKey: `${httpUser}${firstVersoin}/UserHomePage/get_qq_qun_key`,
    },
    capt: {
        // 生成图片验证码
        captImg: `${httpUser}${firstVersoin}${captUrl}/img`,
        // 验证码唯一id
        captbard: `${httpUser}${firstVersoin}${captUrl}/get_background`
    },
    loginHome: {
        // 账号注册
        userInfo: `${httpUser}${firstVersoin}${RegisterUrl}/uname`,
        // 验证账号是否已存在
        accountTest: `${httpUser}${firstVersoin}${RegisterUrl}/accountTest`,
        // 账号登录
        LoginInfo: `${httpUser}${firstVersoin}${loginUrl}/byPwd`,
        // 手机号注册
        UserPhone: `${httpUser}${firstVersoin}${RegisterUrl}/phone`,
        // 账号不存在则注册
        judgePhoneLogin: `${httpUser}${firstVersoin}${RegisterUrl}/byPhoneLogin`,
        // 绑定手机号
        bindPhone: `${httpUser}${firstVersoin}${baseUrl}/bindPhone`,
    },
    game: {
        // 账号注册
        myGames: `${httpContent}${firstVersoin}${homeUrl}/gameindex/myGames`,
        // 删除游戏
        delLatelyGame: `${httpContent}${firstVersoin}${homeUrl}/gameindex/delLatelyGame`,
        // 游戏详情
        gameInfo: `${httpContent}${firstVersoin}${homeUrl}/gameindex/gameInfo`,
        // 游戏礼包码
        getGameGiftCode: `${httpContent}${firstVersoin}${homeUrl}/Gameindex/getGameGiftCode`,
        // 同厂推荐
        firmRecommend: `${httpContent}${firstVersoin}${homeUrl}/gameindex/firmRecommend`,
        // 直接启动游戏
        EnterGame: `${httpContent}${firstVersoin}${homeUrl}/gameindex/EnterGame`,
        // 启动游戏登录器
        EnterGameClient: `${httpContent}${firstVersoin}${homeUrl}/gameindex/EnterGameClient`,
        // 获取下载链接
        getGameLink: `http://tgdata.996box.com/down_url.json`,
    },
    roleInfo: {
        // 游戏充值档位
        PayGrade: `${httpRech}${firstVersoin}${RoleInfoUrl}/GamePayGrade`,
        // 充值账号校验
        CheckUser: `${httpRech}${firstVersoin}${RoleInfoUrl}/CheckUser`,
        // 游戏选择
        UserGames: `${httpRech}${firstVersoin}${RoleInfoUrl}/UserGames`,
        // 玩家区服
        ServerList: `${httpRech}${firstVersoin}${RoleInfoUrl}/ServerList`,
        // 选择角色
        RoleList: `${httpRech}${firstVersoin}${RoleInfoUrl}/RoleList`,
        // 盒子充值档位
        BoxPayGrade: `${httpRech}${firstVersoin}${RoleInfoUrl}/BoxPayGrade`,
        // 盒子充值币种
        getPayInfo: `${httpRech}${firstVersoin}${RoleInfoUrl}/GamePayItem`,
    },
    Pay: {
        // 游戏充值档位
        QrAlipayBox: `${httpRech}${firstVersoin}${payUrl}/QrAlipayBox`,
        // 充值盒子-支付宝扫码
        QrWechatBox: `${httpRech}${firstVersoin}${payUrl}/QrWechatBox`,
        // 直充游戏支付宝扫码
        QrAlipayGame: `${httpRech}${firstVersoin}${payUrl}/QrAlipayGame`,
        // 直充游戏微信扫码
        QrWechatGame: `${httpRech}${firstVersoin}${payUrl}/QrWechatGame`,
        // 用户钱包余额明细
        UserWalletDetailed: `${httpUser}${firstVersoin}${UserWalletUrl}/pc_balance_detailed`,
        // 用户钱包金币明细
        UserGoldDetailed: `${httpUser}${firstVersoin}${UserWalletUrl}/pc_gold_detailed`,
        // 充值状态校验
        PayStatusUrl: `${httpRech}${firstVersoin}${PayStatusUrl}/Check`,
        // 充值游戏-pc余额/金币支付
        BalancePay: `${httpRech}${firstVersoin}${payUrl}/BalancePay`,
        // 余额类型
        screenFactor: `${httpUser}${firstVersoin}${UserWalletUrl}/screen_factor`,
        // 交易类型
        pcScreenFactor: `${httpUser}${firstVersoin}${UserWalletUrl}/pc_screen_factor`,
    },
    PassWord: {
        // 登陆中手机验证码修改密码
        ByPhoneLogin: `${httpUser}${firstVersoin}${PassWordUrl}/changeByPhoneLogin`,
        // 未登录时修改密码
        changeByPhone: `${httpUser}${firstVersoin}${PassWordUrl}/changeByPhone`,
    },
    UploadImage: {
        // 用户上传图片
        UploadImg: `${httpUser}${firstVersoin}${baseUrl}/head_img_upload`,
    },
    Message: {
        // 消息中心--点赞
        Praise: `${httpUser}${firstVersoin}${MessagetUrl}/praise`,
        // 消息中心--回复
        Reply: `${httpUser}${firstVersoin}${MessagetUrl}/reply`,
        // 消息中心--通知
        Notice: `${httpUser}${firstVersoin}${MessagetUrl}/notice`,
        // 系统消息阅读状态更改
        Readnotice: `${httpUser}${firstVersoin}${MessagetUrl}/read_notice`,
        // 点赞阅读状态更改
        Readpraise: `${httpUser}${firstVersoin}${MessagetUrl}/read_praise`,
        // 回复消息阅读状态更改
        Readreply: `${httpUser}${firstVersoin}${MessagetUrl}/read_reply`,
        // 删除系统消息
        Delnotice: `${httpUser}${firstVersoin}${MessagetUrl}/del_notice`,
        // 获取未读消息数量
        MessageNum: `${httpUser}${firstVersoin}${MessagetUrl}/message_num`,
    },
    // 埋点
    operation: {
        // 操作记录
        record: `${httpUser}${firstVersoin}${OperationUrl}/record`,
        // 用户行为记录
        footprint: `${httpUser}${firstVersoin}${OperationUrl}/footprint`,
    }
}
